import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import styles from './heatRange.module.css';
import productStyles from '../../pages/Products/products.module.css';

// Универсальная таблица соответствия калильных чисел (одинакова для всех свечей).
// Строки выровнены по теплоте: сверху — горячее, снизу — холоднее.
const ROWS: { ngk: string; denso: string; champion: string; bosch: string }[] = [
    { ngk: '2',    denso: '9',  champion: '18, 19',    bosch: '10' },
    { ngk: '4',    denso: '14', champion: '14, 16',    bosch: '9' },
    { ngk: '5',    denso: '16', champion: '11, 12',    bosch: '8' },
    { ngk: '6',    denso: '20', champion: '9, 10',     bosch: '6, 7' },
    { ngk: '7',    denso: '22', champion: '7, 8',      bosch: '5' },
    { ngk: '8',    denso: '24', champion: '6, 61, 63', bosch: '4' },
    { ngk: '9',    denso: '27', champion: '4, 59',     bosch: '3' },
    { ngk: '9.5',  denso: '29', champion: '57',        bosch: '' },
    { ngk: '10',   denso: '31', champion: '55',        bosch: '2' },
    { ngk: '10.5', denso: '32', champion: '53',        bosch: '' },
    { ngk: '11',   denso: '34', champion: '',          bosch: '' },
    { ngk: '11.5', denso: '35', champion: '',          bosch: '' },
    { ngk: '12',   denso: '37', champion: '',          bosch: '' },
];

// Цвет градиента слева: красный (горячее) → синий (холоднее)
const heatColor = (i: number): string => {
    const k = i / (ROWS.length - 1);
    const r = Math.round(229 + k * (50 - 229));
    const g = Math.round(57 + k * (120 - 57));
    const b = Math.round(53 + k * (229 - 53));
    return `rgb(${r}, ${g}, ${b})`;
};

const HeatRangeChart: FC = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(true);

    return (
        <div className={productStyles.ref_container}>
            <button className={productStyles.section_toggle} onClick={() => setOpen((o) => !o)}>
                <span className={productStyles.ref_num}>{t('product_features.heat_range_chart')}</span>
                {open ? <FaChevronUp /> : <FaChevronDown />}
            </button>

            {open && (
                <div className={styles.body}>
                    <div className={styles.scroll}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th className={styles.label_hot}>{t('product_features.hotter')}</th>
                                    <th>NGK</th>
                                    <th>DENSO</th>
                                    <th>CHAMPION</th>
                                    <th>BOSCH</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ROWS.map((row, i) => (
                                    <tr key={i}>
                                        <td className={styles.grad} style={{ background: heatColor(i) }} />
                                        <td>{row.ngk || '—'}</td>
                                        <td>{row.denso || '—'}</td>
                                        <td>{row.champion || '—'}</td>
                                        <td>{row.bosch || '—'}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td className={styles.label_cold}>{t('product_features.colder')}</td>
                                    <td colSpan={4} />
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div className={styles.notes}>
                        <p>{t('product_features.heat_note_approx')}</p>
                        <p>{t('product_features.heat_note_acdelco')}</p>
                        <p>{t('product_features.heat_note_motorcraft')}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default HeatRangeChart;
